// Typelizer digest 4c049771644ae5ad998af9df80351beb
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/documents/:document_id/review */
  show: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/review', params, options),
    method: 'get',
  }),
}
